import React from 'react';
import { Button } from 'antd';
import cn from 'classnames';
import styles from './AddFieldsBtn.module.scss';

const AddFieldsBtn = ({ className, onClick, text }) => {
  return (
    <Button
      icon="plus-circle"
      ghost
      block
      className={cn(styles.root, className)}
      onClick={onClick}
    >
      {text || ''}
    </Button>
  );
};

export default AddFieldsBtn;
